// CDR QoS:

// {{{ CDR.QosScreen

GW.define('CDR.QosScreen', 'Main.Screen', {
	title: _('CDR QoS'),
	titleIcon: 'phone-calls-filled',

	'after:initComponent'() {
		let me = this;

		this.el.classList.add('cdr-history-screen');
		this.bodyEl.gwReplaceChildren([{
			ref: 'toolbarEl',
			nodeName: 'form',
			'on:submit': ev => {
				ev.preventDefault();
				this.reload();
			},
			className: 'toolbar',
			children: this.renderToolbar(),
		}, {
			ref: 'table',
			xtype: 'FilterableSmartTable',
			extraClass: 'panel-container no-padding cdr-smart-table',
			getColumns() {
				return me.getColumns();
			},
		}], this);

		setTimeout(() => {
			// help firefox
			let el = this.el.querySelector('[autofocus]');
			el && el.focus();
		}, 0);

		for (let f of this.getLiveToolbarSearchFields()) {
			f.on('change', c => this.updateParams());
		}
	},

	getLiveToolbarSearchFields() {
		return this.getChildren(c => {
			return c.fromParams && c.toParams && c.toQuery && c.el.closest('.toolbar');
		});
	},

	getColumns() {
		
		function formatPercent(td, v, row) {
			if (v == null) {
				td.textContent = '';
				return;
			}
			v = Math.round(v * 10000) / 100;
			td.textContent = v + '\u2009%';
		}
		
		function formatMillis(td, v, row) {
			if (v == null) {
				td.textContent = '';
				return;
			}
			v = Math.round(v * 100) / 100;
			td.textContent = v + '\u2009ms';
		}
		
		return [{
			id: 'linked_id',
			name: _('Linked ID'),
			format: 'string',
			sortable: {
				type: 'string',
			},
		}, {
			id: 'ts',
			name: _('Čas'),
			format: 'datetime',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'user_name',
			name: _('Uživatel'),
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'client_ip',
			name: _('IP adresa klienta'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string'
			},
		}, {
			id: 'sip_dir',
			name: _('Směr'),
			format: 'call_direction',
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			}
		}, {
			id: 'sip_local',
			name: _('Lokální číslo'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'numeric'
			},
		}, {
			id: 'sip_remote',
			name: _('Vzdalené číslo'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_recv_loss',
			name: 'pkt_recv_loss',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_recv',
			name: 'pkt_recv',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_disc',
			name: 'pkt_disc',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_recv_loss_pct',
			name: 'pkt_recv_loss_pct',
			formatCell: formatPercent,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_sent_loss',
			name: 'pkt_sent_loss',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_sent',
			name: 'pkt_sent',
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'pkt_sent_loss_pct',
			name: 'pkt_sent_loss_pct',
			formatCell: formatPercent,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'local_jitter',
			name: 'local_jitter',
			formatCell: formatMillis,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'remote_jitter',
			name: 'remote_jitter',
			formatCell: formatMillis,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'outbound_rtt',
			name: 'outbound_rtt',
			formatCell: formatMillis,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'inbound_rtt',
			name: 'inbound_rtt',
			formatCell: formatMillis,
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'user_agent',
			name: _('User Agent'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'network_changes',
			name: _('Siť'),
			width: 20,
			filter: {
				type: 'options',
				showSearch: true,
			},
			formatCell: (td, v, row) => {
				if (!v) {
					td.textContent = '';
					return;
				}

				td.gwReplaceChildren([{
					nodeName: 'span',
					textContent: v.map(v => v.transport)
						.filter(s => s)
						.join(', ').split(', ')
						.filter((v, i, arr) => arr.indexOf(v) == i) // unique
						.join(', '),
					title: v.map(ch => {
						
						let prefix = Formats.time_millis(ch.ts) + ', ' + ch.network + ' ';
						
						if (ch.type == 'AVAILABLE') {
							return prefix + _('Připojeno');
						}
						if (ch.type == 'LOST') {
							return prefix + _('Odpojeno');
						}
						
						return prefix + 'up: ' + ch.bandwidthKbpsUp + ', ' +
							'down: ' + ch.bandwidthKbpsDown + ', ' +
							(ch.signalStrength ? ('signal: ' + ch.signalStrength) : ''); 
						
					}).join("\n")
				}]);
			}
		}];
	},
	
	renderToolbarSearchFields() {
		return [{
			xtype: 'Widgets.DateRangeInput',

			async fromParams(params) {
				let range = params.get('range') || 'today';

				await this.setRangeOption(range);

				if (range == 'custom') {
					this.setTimeRange(
						params.get('since'),
						params.get('until')
					);
				}
			},
			toParams(params) {
				let range = this.getRange();
				if (range == 'custom') {
					let [since, until] = this.getTimeRange();
					params.set('since', since || '');
					params.set('until', until || '');
					params.set('range', range);
				} else {
					params.delete('since');
					params.delete('until');
					params.set('range', range);
				}

				this.updateTimeFields();
			},
			toQuery(query) {
				let [since, until] = this.getTimeRange();

				query.since = since;
				query.until = until;
			},
		}, {
			xtype: 'TextField',
			extraClass: 'small',
			label: _('Linked Id'),
			optional: true,

			fromParams(params) {
				this.setValue(params.get('linked_id') || '');
			},
			toParams(params) {
				let number = this.getValue() || '';
				if (number) {
					params.set('linked_id', number);
				} else {
					params.delete('linked_id');
				}
			},
			toQuery(query) {
				query.linked_id = this.getValue() || undefined;
			},
		}];
	},

	renderToolbar() {
		return [...this.renderToolbarSearchFields(), {
			nodeName: 'button',
			type: 'submit',
			className: 'primary small',
			textContent: _('Zobrazit'),
		}, {
			nodeName: 'button',
			type: 'button',
			className: 'secondary small',
			textContent: _('Exportovat XLSX'),
			"on:click": () => {
				let params = new URLSearchParams(JSON.parse(JSON.stringify(this.buildQuery())));
				location.href = API_BASE + 'calls-qos/export/xlsx?' + params.toString();
			},
		}];
	},


	/*
	 * Update URL query parameters from the input fields.
	 */
	updateParams() {
		Application.route({
			resolve: false,
			paramsFn: params => {
				for (let f of this.getLiveToolbarSearchFields()) {
					f.toParams(params);
				}

				return params;
			},
		});
	},

	maxCalls: 3000,

	buildQuery() {
		let query = {
			limit: this.maxCalls,
		};

		for (let f of this.getLiveToolbarSearchFields()) {
			f.toQuery(query);
		}

		return query;
	},

	async reload() {
		let list = await REST.GET('calls-qos', this.buildQuery());
		if (list.length >= this.maxCalls) {
			Application.notify({
				text: _('Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte jiný filtr.')
					.replace('{max}', this.maxCalls),
			});
		}

		this.table.setData(list);
	},

	async applyParams(params) {
		for (let f of this.getLiveToolbarSearchFields()) {
			f.fromParams(params);
		}
	},
});


// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	module: 'cdrqos',
	path: APP_BASE + 'cdrqos',
	async handler({params}) {
		let c = Application.show({
			id: 'cdr.qos',
			title: _('CDR QoS'),
			xtype: 'CDR.QosScreen',
		});

		c.applyParams(params);
	},
}]);

Application.registerModule({
	id: 'cdrqos',
	title: _('CDR QoS'),
	tagline: _('Statistiky hovorů'),
	icon: 'phone-calls',
	href: APP_BASE + 'cdrqos',
});
